import axios from '../javascript/custom-axios';
const RESOURCE_NAME = 'ups';

export default {
  oauthUPS(body) {
    return axios.post(`${RESOURCE_NAME}/authorization`, body);
  },
};
